import { render, staticRenderFns } from "./OceanPackageReturns.vue?vue&type=template&id=7e993ad3"
import script from "./OceanPackageReturns.vue?vue&type=script&lang=js"
export * from "./OceanPackageReturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports